<template>
    <q-btn outlined unelevated no-caps :disable="isDisableBtn" @click="onBtn" class="penal__content">
        <span class="full-screen flex align-left + justify-between">
            <span class="flex align-center txt_left notice__name">
                <img v-if="props.informData?.topFixYn" class="dot" src="/assets/images/icon/img_mypage_pin.png" />
                <span v-if="props.informData?.type" class="txtNormal text-bold q-px-md text-primary b3">{{ props.informData?.type }}</span>
                <span v-if="props.informData?.title" class="informTt30">{{ props.informData?.title }}</span>
                <img v-if="props.informData?.isNew" class="new" src="/assets/images/icon/img_mypage_New.png" />
            </span>
            <span class="dateTt30">{{ props.informData?.createdTs }}</span>
        </span>
    </q-btn>
</template>
<!-- {
    "seq": 13,
    "title": "알림제목12",
    "contents": "알림내용12",
    "creatorName": "관리자",
    "createdTs": "2023.02.23"
  }, -->
<script setup>
import { onMounted, computed, ref, watch, defineProps, defineEmits } from 'vue';

const props = defineProps({
    type: {
        Type: Number,
    },
    informData: {
        Type: Object,
    },
    isDisableBtn: {
        Type: Boolean,
        default: false,
    },
});
const emit = defineEmits(['onOpen']);

const onBtn = () => {
    emit('onOpen', props.informData);
};

onMounted(() => {
    // console.log('--item-informData-', props.informData);
});
</script>

<style scoped lang="scss">
.purple {
    color: purple;
}
.red {
    color: red;
}
.q-btn {
    border-radius: 10px;
}

.penal__content {
    display: block;
    width: 100%;
    padding: 3.17vmin 5.67vmin 3.08vmin;
    border: 1px solid #e0e0e0;
    background-color: white;
    text-align: left;

    &:first-of-type {
        margin-top: 5.67vmin;
    }

    &:nth-of-type(n + 2) {
        margin-top: 1.33vmin;
    }

    .full-screen {
        width: 100%;
        .flex {
            align-items: center;
        }
    }

    .dot {
        display: inline;
        width: 0.8vw;
        height: 0.8vw;
        margin-right: 2.17vmin;
    }

    .new {
        display: inline;
        width: 1.6vw;
        margin-left: 0.67vmin;
    }
}
/*
.notice__name .informTt30 {
    display: inline-block;
    // width: 40%;
    max-width: 70%;
    @include text-ellipsis;
    text-align: left;
}
*/
.align-center {
    align-items: center;
}
</style>
